export default __webpack_public_path__ + "static/media/person_pin_black_48dp.12d2d201.svg";